import React, { FC, useRef, useEffect } from "react"
import { useCreation } from "ahooks"
import ReactEcharts from "echarts-for-react"
import { EChartOption } from "echarts"
import Env from "@util/env"

type ILabelRatioPieProps = {
  data: { name: string; value: number }[]
}

const LabelRatioPie: FC<ILabelRatioPieProps> = ({ data }) => {
  const ref = useRef()
  const o = data.reduce((a, c) => {
    a[c.name] = c
    return a
  }, {})
  const option = useCreation<EChartOption>(() => {
    return {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {d}%",
      },
      legend: {
        orient: "vertical",
        top: "center",
        right: 10,
        itemHeight: 10,
        itemWidth: 10,
        textStyle: {
          color: "rgba(162,171,179,1)",
          fontSize: 14 * Env.getScale(),
        },
        formatter: function (name) {
          return `${name} ${Math.round(o[name].value * 10000) / 100}%`
        },
      },
      color: [
        "rgba(79, 180, 255, 1)",
        "rgba(0, 252, 239, 1)",
        "rgba(248, 201, 106, 1)",
      ],
      series: [
        {
          type: "pie",
          radius: ["50%", "80%"],
          center: ["30%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data,
        },
      ],
    }
  }, [data])
  useEffect(() => {
    return () => {
      // @ts-ignore
      ref.current && ref.current.getEchartsInstance().dispose()
    }
  }, [ref])
  return (
    <div className="ct-pie-legend" style={{ height: "100%" }}>
      <ReactEcharts
        ref={ref}
        option={option}
        notMerge={true}
        lazyUpdate={true}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  )
}

export default LabelRatioPie
